export interface PrismContextMenuData {
    positionsCount: number;
    isMinimumVertexNumber: boolean;
    onFinishCreate: () => void;
    onRemoveLastPoint: () => void;
    onRemoveArea: () => void;
}

export interface PrismContextMenu {
    data: PrismContextMenuData;
}
